<template>
<div>
    <div v-if="importantTasks.length" class="important-tasks">
        <div style="font-size:10px;color:#666">
            Important Clients
        </div>
        <span class="clickable">
        <v-chip class="mr-1"  
            @click="taskClicked(importantTask)" v-for="importantTask in importantTasks" 
            :title="importantTask.title" dark :color="importantTaskColour(importantTask)" :key="importantTask.meta.key">
                {{importantTask.clients}}
        </v-chip>
        </span>
    </div>
    <div style="margin-bottom:-8px;margin-left:85px;color:#bbb">
        {{transactionCount + ' client' + (transactionCount != 1 ? 's' : '')}}
    </div>
    <div class="task-list">

    <div v-for="(lender, index) in lenderTasks" class="picture-card" style="" :key="index">

            <div :title="lender.name" class="round-picture subtle-shadow picture-card-picture" 
             :style="`background-image:url(/static/images/lenders/${encodeURI(lender.name)}.jpg)`"></div>

        <div style="width:100%">
            <div style="border-radius:8px;padding:6px;background-color:white;" class="elevation-2">
            <div v-for="(transaction, transactionIndex) in lender.transactions" class="transaction-card clickable" @click="transactionClicked(transaction)" :key="transactionIndex">
                <div style="float:right;margin-top:-10px;margin-right:-10px">
                    <a @click.stop class="transparent" target="_blank" :href="transactionLink(transaction)" title="Open in new Tab">
                        <v-btn text class="open-in-new" icon color="grey">
                        <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                    </a>    
                </div>
                <b >{{transaction.clients || 'No Name'}}</b><v-btn class="no-focus" small icon><v-icon @click.stop="loadTransactionDetails(transaction)" small color="grey lighten-2">mdi-chevron-down-circle</v-icon></v-btn>
                
                <v-expand-transition>
                    <span v-if="settings.condensed">
                        <span v-for="task in transaction.tasks" @click.stop="taskClicked(task)" :key="task._key">
                            {{task.title}}
                        </span>
                    </span>
                    <div v-if="transaction.description">
                        {{transaction.description}} 
                        <span v-if="transaction.broker" class="light-text small-text"> (Broker: {{transaction.broker}})</span>
                    </div>
                </v-expand-transition>

                <div class="pt-1" v-if="!settings.condensed">

                    <div v-for="task in transaction.tasks" class="pa-1 task-row hover-container clickable" @click.stop="taskClicked(task)" :key="task.key">
                        <ul>
                            <li>
                                <div v-if="daysTillDue(task) < 0" style="border-radius: 2px;margin-bottom:-1px;margin-right:2px;width:12px;height:12px;background-color:#ccc;display:inline-block" class="red darken-1"></div>
                                <span v-if="task.sectionTitle">{{task.sectionTitle}} ></span>
                                {{task.title || task.text}}
                                <b v-if="settings.showInitials">{{initials(task.assigned)}}</b>
                                <Flag primary v-if="task.important">Important</flag>
                                <flag>{{task.status}}</flag>
                                <span v-if="daysTillDue(task) != 0" class="grey--text text--lighten-1"> ({{task.due | dueString}})</span>
                                <v-btn class="task-edit show-on-hover" @click.stop="openTask(task)" small icon>
                                    <v-icon small color="grey" >edit</v-icon> 
                                </v-btn>
                            </li>
                        </ul>
            
                    </div>
                </div>

            </div>
            </div>
        </div>
    </div>
    </div>



    
    <!-- Dialog Box -->
    <TaskDialog :task="taskDialog.model" :settings="taskDialog.settings" @save="saveTask" />

</div>
</template>

<script>
import TaskDialog from '../ui-elements/TaskDialog'
import LookupData from '../helpers/LookupData'
import ArrayHelpers from '../helpers/ArrayHelpers'
import StringHelpers from '../helpers/StringHelpers'
import Flag from '../ui-elements/Flag'
import ContactHelpers from '../helpers/ContactHelpers'
import NiceData from '../data/NiceData'
import TenantHelpers from '../helpers/TenantHelpers'
import {differenceInCalendarDays} from 'date-fns'
import DateHelpers from '../helpers/DateHelpers'
import TransactionHelpers from '../helpers/TransactionHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import DataHelpers from '../helpers/DataHelpers'

export default {
data() {
    return {
        taskDialog: {
            settings: {
                visible: false,
                title: 'Task Details',
            },
            model: {
                key: null,
                title: null,
                due: null,
                assigned: {},
            }
        },         
    }
},

props: {
    tasks: Array,
    settings: Object,
},
components: {
    TaskDialog,
    Flag, 
},

computed: {
    lenders() {
        return LookupData.lenders().map(o => o.name)
    },

    importantTasks() {
        return this.tasks.filter(o => o.important)
    },

    transactionCount() {
        let count = 0
        for(let n in this.lenderTasks) {
            
            count += Object.keys(this.lenderTasks[n].transactions).length
        }
        return count
    },

    lenderTasks() {
        let result = {}
        this.tasks.sort( function(a,b) {
            a.lender = a.lender || 'Zero'
            b.lender = b.lender || 'Zero'
            if (a.lender < b.lender)
                return -1
            if (a.lender > b.lender)
                return 1
            return 0
        })

        this.tasks.forEach(task => {
            let taskKey = NiceData.safelyGetKey(task)
            let lender = task.lender || 'No Lender'
            let transactionKey = task.transactionKey
            let tenantKey = task.tenantKey

            if(!result[lender])
                result[lender] = {}

            let lenderObj = result[lender]
            lenderObj.name = lender

            
            if(!lenderObj.transactions)
                lenderObj.transactions = {}

            if(!lenderObj.transactions[transactionKey]) {

                lenderObj.transactions[transactionKey] = {
                    tenantKey: tenantKey,
                    key: transactionKey,
                    description: task.transactionDescription || '',
                    broker: task.transactionBroker || '',
                    clients: task.clients,
                    tasks: {}
                }
            }

            result[lender].transactions[transactionKey].tasks[taskKey] = {
                ...task
            }

            lenderObj.multipleTransactions = Object.keys(lenderObj.transactions).length
        })

        return result
    }
},

methods: {

    loadTransactionDetails(transaction) {
        //already loaded
        if(transaction.description)
            return
        
        let transactionRef = DataHelpers.getTransactionRef(transaction.key, transaction.tenantKey)
        let ref = transactionRef.child('details')
        NiceData.fetchItemSingle(ref).then(transObj => {
            let elementRef = transactionRef.child('elements')
            NiceData.fetchItemByName(elementRef, 'broker').then(brokerElement => {
                let broker = ''
                if(brokerElement)
                    broker = brokerElement.value
                    //this.$set(transaction, 'broker', brokerElement.value)
                const description = transObj ? transObj.description : 'Transaction not found for this task'
                let tasks = this.tasks.filter(t => t.transactionKey == transaction.key)
                tasks.forEach(task => {
                    this.$set(task, 'transactionDescription', description)
                    this.$set(task, 'transactionBroker', broker)
                })
            
            }) 

        })
       
    },

    importantTaskColour(task) {
        const days = this.daysTillDue(task)
        
        if(days < 0)
            return 'red darken-2'

        if(days == 0)
            return 'primary'
        
        return 'grey darken-1'
    },
    initials(user) {
        return ContactHelpers.initials(user)
    },

    openAll(lender) {
        let delay = 1000
        for(var transaction in lender.transactions) {
            setTimeout(()=>{

                console.log('opening transaction', transaction)
                this.transactionSpawn(transaction)
            }, delay)
            delay += 1000
        }
    },

    transactionLink(transaction) {
        let task = this.transactionFirstTask(transaction)
        let path = StringHelpers.rootPath() + task.meta.tenantKey + '/transaction/' + task.transactionKey
        return path
    },
    taskClicked(task) {
        console.log('taskClicked', task)
        TenantHelpers.setTenant(task.meta.tenantKey)
        this.$emit('clicked', task)
    },
    transactionClicked(transaction) {
        const firstTask = this.transactionFirstTask(transaction)
        // delete firstTask.tabKey
        this.taskClicked(firstTask)
    },
    transactionFirstTask(transaction) {
        const firstKey = Object.keys(transaction.tasks)[0]
        const firstTask = {...transaction.tasks[firstKey]}
        return firstTask
    },
    daysTillDue(task) {
        if(!task.due)
            return null

        return differenceInCalendarDays(DateHelpers.backwardsToDate(task.due), new Date())
    },
    openTask(task) {
        TenantHelpers.setTenant(task.meta.tenantKey)        
        this.taskDialog.model = {...task} 
        this.taskDialog.settings.visible = true
    },
    saveTask(task) {
        console.log('tasksByLender > saveTask')
        this.$store.dispatch('saveTask', task)
    },        
}
}
</script>

<style scoped>
.round-picture {
    height:60px;width:60px;
    border-radius:50%;
    border:solid 3px #f5f5f5;
    background-size: cover;
    background-position: center center;
}
.task {
    padding:10px
}
.task-row{
    border-radius:15px;
}
.transaction-card {
    padding:6px; 
    background-color: white;
}

.task-row:hover {
    background-color: #eeeeee;
}

.task-edit {
    float:right;margin-top:-3px;margin-bottom:3px;margin-right:0
}

.transaction-card .open-in-new {
    transition:opacity 0.5s ease-in-out;
    opacity: 0.2;
}

.transaction-card:hover .open-in-new {
    opacity: 1;
}

.task-list {
    padding:0 5px; max-width: 900px;
}

.picture-card {
    position:relative;padding:10px 0 8px 80px;margin-bottom:4px;width:100%;
    transition: padding-left .5s ease-in-out;
}

.picture-card-picture {
    position:absolute;display:inline-block;left:4px; top:5px; margin-right:20px;
    transition: all .5s ease-in-out;
}

.important-tasks {
    padding: 8px 8px 8px 8px;
}

@media (max-width: 640px) {
  .picture-card {
        padding-left:0;
  }

  .picture-card-picture {
      left:calc(50% - 35px);top: -38px;
  }

  .task-list {
      margin-top:30px;
  }
  
}

</style>




// WEBPACK FOOTER //
// TasksByLender.vue?58366d67